import { render, staticRenderFns } from "./baseLayout.vue?vue&type=template&id=a2ca8b6e&scoped=true"
import script from "./baseLayout.vue?vue&type=script&lang=ts"
export * from "./baseLayout.vue?vue&type=script&lang=ts"
import style0 from "./baseLayout.vue?vue&type=style&index=0&id=a2ca8b6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ca8b6e",
  null
  
)

export default component.exports